import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class TimelineService {
    static getTimelineForAccount(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('journeyTimeline'), 'getTimelineForAccount', [accountNumber], additionalHeaders);
    }
}
